import React from 'react';
import { LoadingOval, LoadingGIF, LoadingWhiteGIF } from "../Assets";
import { Modal } from "../Modal";
import "./style.scss";

export class AppErrorBoundry extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo)
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className='col full flex-ctr h-ctr v-ctr'>
          <h1>{this.props.message || 'Something went wrong. Please check logs'}</h1>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScreenComponent = (props) => {
  const { className } = props;
  return (
    <div className={'col full home ' + (className || '')}>
      {props.children}
    </div>
  )
}
export const Screen = ScreenComponent


export const OvalLoading = (props) => {
  const { isWhite } = props;
  return (
    <div className={`col w-100 h-100 h-ctr v-ctr loading-indicator ${props.isSmall ? 'small' : ''}`}>
      <LoadingOval className="loading-oval" />
      <div className="row h-ctr v-ctr">
        {isWhite ? <LoadingWhiteGIF className="loading" /> : <LoadingGIF className="loading" />}
        <span className={`exo2 msg ${props.messageClassName || ''}`}>{props.message || 'Please Wait...'}</span>
      </div>
    </div >
  )
}

export const OvalLoadingModal = (props) => {
  const { open, ...rest } = props
  return (
    <Modal
      open={open}
      width={517}
      className='loading-modal'>
      {
        open &&
        <OvalLoading isWhite {...rest} />
      }
    </Modal>
  )
}

